export const markAsLostTexts = {
    label: 'Marcar como perdida',
    observationLabel: 'Motivo (opcional)',
    successMessage: 'Oportunidade marcada como perdida!',
    hint: 'Marca a oportunidade como perdida.',
}

export const lossReasons = {
    refusal: 'refusal',
    notNow: 'not_now',
    otherSellerCustomer: 'other_seller_customer',
};

export const lossReasonOptions = [
    { key: lossReasons.refusal, label: 'Pediu para não ser abordado' },
    { key: lossReasons.notNow, label: 'Agora não / sem condições agora' },
    { key: lossReasons.otherSellerCustomer, label: 'Cliente de outro consultor' },
];
